import get from 'get-value';
import { getWidthPlusMargin } from "./getWidthPlusMargin";
export var getNavigationItemsWidth = function getNavigationItemsWidth(headerElement) {
  var navigationElement = get(headerElement, ['children', 0, 'children', 1]);
  return navigationElement ? Array.from(navigationElement.children).reduce(function (accumulator, navigationItem) {
    return accumulator + getWidthPlusMargin(navigationItem);
  }, 0) : 0;
};